import { Ifilter } from "../../filter";

export interface ITableModeloEquipo {
  equipoModeloId;
  equipo;
  string;
  tipoEquipo: string;
  fecha: string;
}
export interface ITableModeloEquipoEdit {
  equipoModeloId;
  equipo?:string;
  codigo?:string;
  tipoEquipoId?: string;
}
export interface IRequestModeloEquipoAuxiliar extends Ifilter{
  equipoAuxiliar?:boolean
}
export interface IGetPersonaByEquipo {
  skip: number;
  take: number;
  search?: string | null;
  equipoModeloId: string;
}
export interface IPersonaByEquipo {
  nombre: string;
  nroDoi: string;
  area: string;
  personaId: string;
  equipoModeloId: string;
}

export interface IPostCrearModeloEquipo {
  equipoModeloId: string;
  tipoEquipoId: string;
  nombreModelo: string;
  equipoAuxiliar?:boolean
}

export const initialPostCrearModeloEquipo:IPostCrearModeloEquipo = {
  tipoEquipoId: "",
  nombreModelo: "",
  equipoModeloId: ""
}
export interface IPostModeloAuxiliar {
  equipoModeloId: string;
}

export const initialPostModeloAuxiliar: IPostModeloAuxiliar = {
  equipoModeloId: ""
};

export const initialPostCrearModeloEquipoAuxiliar:IPostCrearModeloEquipo = {
  equipoModeloId: "",
  tipoEquipoId: "",
  nombreModelo: "",
  equipoAuxiliar:true
};
